import { arePluginsSatisfied } from '~~/shared-components/modules/plugins/plugin-types'
import type { PluginRequirement } from '~~/shared-components/modules/plugins/plugin-types'

export const usePlugins = () => {
  const { $sharedComponentsPlugins, $config } = useNuxtApp()

  const plugins = useState<{ [key: string]: boolean } | null>(
    'plugins',
    () => ($config.public.projectPlugins as { [key: string]: boolean } | undefined) ?? null
  )

  const hasPlugins = (p: string | PluginRequirement[]) => {
    if (!$config.public?.projectPluginsEnabled && !$sharedComponentsPlugins?.plugins) {
      return true
    }
    return arePluginsSatisfied(p, (plugin) => plugins.value?.[plugin] === true)
  }

  return { hasPlugins }
}
